import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77a3d7ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anchor" }

import { provide, reactive } from 'vue';
export type AnchorStroe = {
  currentHref: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'anchor',
  setup(__props) {

const currentHref = reactive<AnchorStroe>({
  currentHref: '',
});
provide('anchor', currentHref);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})